import * as API from '@/api';

export const actions = {
  // R: 取得香科年介紹文章列表
  async getFestivals({ commit }) {
    const list = await API.GET('/festivals?limit=6');

    // 濾掉下架的文章
    list.data.data = list.data.data.filter((festival) => !!festival.is_on);

    commit('setFestivals', list.data);
  },

  // R: 取得一篇香科年介紹文章
  async getFestival({ commit }, articleId) {
    const festival = await API.GET(`/festivals/${articleId}`);

    commit('setFestival', festival.data);
  },

  // R: 取得藝陣與特展列表
  async getSkills({ commit }) {
    const list = await API.GET('/skills?limit=6');

    // 濾掉下架的文章
    list.data.data = list.data.data.filter((skill) => !!skill.is_on);

    commit('setSkills', list.data);
  },

  // R: 取得一篇藝陣與特展文章
  async getSkill({ commit }, articleId) {
    const skill = await API.GET(`/skills/${articleId}`);

    commit('setSkill', skill.data);
  },

  // R: 取得活動資訊列表
  async getInfos({ commit }) {
    const list = await API.GET('/activityInfos?limit=6');

    commit('setActivityInfos', list.data);
  },

  // R: 取得一篇活動資訊
  async getInfo({ commit }, articleId) {
    const activityInfo = await API.GET(`/activityInfos/${articleId}`);

    commit('setActivityInfo', activityInfo.data);
  },

  // R: 取得最新消息列表
  async getNewsList({ commit }) {
    const list = await API.GET('/newInfos?limit=6');

    commit('setNewInfos', list.data);
  },

  // R: 取得一篇最新消息
  async getNews({ commit }, articleId) {
    const newInfo = await API.GET(`/newInfos/${articleId}`);

    commit('setNewInfo', newInfo.data);
  },

  // R: 取得最新消息列表
  async getEnglishList({ commit }) {
    const list = await API.GET('/englishes?limit=6');

    commit('setEnglishes', list.data);
  },

  // R: 取得一篇最新消息
  async getEnglish({ commit }, articleId) {
    const english = await API.GET(`/englishes/${articleId}`);

    commit('setEnglish', english.data);
  },

  // R: 取得歷史回顧
  async getHistory({ commit }, params) {
    const defaultParams = {
      limit: 6,
      type: 1,
      page: 1,
    };
    const history = await API.GET('/retrospects', {
      ...defaultParams,
      ...params,
    });

    commit('setHistory', history.data);
  },
};
